// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ciam-brand-logo{display:inline-block;height:40px;width:40px;background-image:none;background-size:cover;background-position:50%;vertical-align:sub}.brand-desc{text-align:center}", ""]);
// Exports
module.exports = exports;
